import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import { getRoleFromLocal } from "../globals/authentication";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";

const StyledCard = styled(Card)`
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
`;

const VerifactionTaskCards = ({ tasks }) => {
  const [role, setRole] = useState("");
  const { t } = useTranslation();

  const formatDateAndTime = (isoString) => {
    const date = new Date(isoString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const amOrPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format

    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${amOrPm}`;
  };

  useEffect(() => {
    const userRole = getRoleFromLocal();
    setRole(userRole);
  }, []);

  return (
    <div style={{ marginTop: "10px" }}>
      {tasks.map((dispute) => (
        <StyledCard
          key={dispute.id}
          sx={{ my: 3, borderRadius: 3 }}
          elevation={2}
        >
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              {t("Claim")}: {dispute.title}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              {t("Description")}: {dispute.description?.substring(0, 50)}...
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              {t("Request by")}: {dispute.requester.username}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              {t("Deadline")}: {formatDateAndTime(dispute.deadline)}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              {t("Approval(%)")}: {dispute.response_stats?.accept_percentage}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              {t("Approvals")}: {dispute.response_stats?.yes}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              {t("Disputes")}: {dispute.response_stats?.no}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              {t("Indeterminate")}: {dispute.response_stats?.indeterminate}
            </Typography>

            {role !== "FARMER" && (
              <Box display="flex" justifyContent="flex-end">
                <Button
                  sx={{ marginTop: 10 }}
                  variant="contained"
                  color="primary"
                  onClick={() => window.open(`/verify/${dispute.id}`, "_self")}
                >
                  {t("Action")}
                </Button>
              </Box>
            )}
          </CardContent>
        </StyledCard>
      ))}
    </div>
  );
};

export default VerifactionTaskCards;
